import { Injectable } from '@angular/core';
import { CalendarioEventi } from 'src/app/models/calendarioeventi';
import { CalendarioEventiPrivati } from 'src/app/models/calendario-eventi-privati';

@Injectable({
    providedIn: 'root'
  })
  export class EventsCalendarStore {

    records: CalendarioEventi[];
    privateRecords: CalendarioEventiPrivati[];

    showLoader = false;

    constructor() {
        this.records = [];
        this.privateRecords = [];
    }
}
